var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{class:['mdc-snackbar', _vm.error && 'error']},[_c('div',{staticClass:"mdc-snackbar__surface",attrs:{"role":"status"}},[_c('div',{ref:"label",staticClass:"mdc-snackbar__label",attrs:{"aria-live":"polite"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }